import React from "react"    
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { useIsAuthenticated } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import EditDocument  from "@pages/EditDocument/EditDocument";
import { IPublicClientApplication } from "@azure/msal-browser";

function handleLogin(instance: IPublicClientApplication) {
    instance.loginRedirect(loginRequest).catch((e) => {
        console.error(e);
    });
}

export const App: React.FC = () => {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();

    if (!isAuthenticated) {
        handleLogin(instance);
        return <></>;
    }

    return <EditDocument /> ;
};

export default App;
